import useMyApiClient from "./useMyApiClient";

/**
 * Custom params serializer for axios that handles arrays as multiple query params
 * @param {Object} params - Parameters object
 * @returns {string} Serialized query string
 */
function paramsSerializer(params) {
  const searchParams = new URLSearchParams();

  for (const [key, value] of Object.entries(params)) {
    if (value === null || value === undefined) {
      continue;
    }

    if (Array.isArray(value)) {
      // Serialize arrays as multiple query params: key[]=value1&key[]=value2
      value.forEach((item) => {
        if (item !== null && item !== undefined) {
          searchParams.append(`${key}[]`, String(item));
        }
      });
    } else {
      searchParams.append(key, String(value));
    }
  }

  return searchParams.toString();
}

function useMyService() {
  const myApiClient = useMyApiClient();

  function getAllEntities({ params, page = 0, size = 100, endpoint, signal }) {
    const allParams = { page, size, ...params };
    return myApiClient
      .get(endpoint, {
        params: allParams,
        paramsSerializer,
        signal,
      })
      .then((response) => response.data);
  }

  function getEntityById({ id, params, endpoint, signal }) {
    const endpointNew = `${endpoint}/${id}`;

    return myApiClient
      .get(endpointNew, {
        params,
        signal,
      })
      .then((response) => {
        return response.data;
      });
  }

  const addEntity = ({ dataObj, endpoint, signal }) => {
    return myApiClient
      .post(endpoint, dataObj, signal)
      .then((response) => response.data);
  };

  const updateEntity = async ({ dataObj, endpoint, signal }) => {
    const endpointNew = `${endpoint}/${dataObj.id}`;

    return myApiClient
      .put(endpointNew, dataObj, signal)
      .then((response) => response.data);
  };

  const deleteEntity = async ({ id, endpoint, signal }) => {
    const endpointNew = `${endpoint}/${id}`;

    return myApiClient
      .delete(endpointNew, signal)
      .then((response) => response.data);
  };

  return {
    getAllEntities,
    getEntityById,
    addEntity,
    updateEntity,
    deleteEntity,
  };
}
export default useMyService;
